var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcErrorFace(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 112,
    height: 112,
    viewBox: "0 0 112 112",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_76_6061)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.9997 0.000488281C25.1439 0.000488281 0 25.1443 0 56.0002C0 86.856 25.1439 112 55.9997 112C86.8555 112 111.999 86.856 111.999 56.0002C111.999 25.1443 86.8555 0.000488281 55.9997 0.000488281ZM38.8582 33.1411C41.7142 33.1411 44.5701 35.9971 44.5701 38.8531C44.5701 41.7146 41.7142 44.5706 38.8582 44.5706C36.0022 44.5706 33.1462 41.7146 33.1462 38.8587C33.1462 36.0027 36.0022 33.1411 38.8582 33.1411ZM76.5684 81.7152C75.9972 82.8576 74.2836 83.4288 73.1412 83.4288C71.9988 83.4288 71.4276 83.4288 70.2852 82.2864C65.1444 78.8592 61.7172 77.7168 55.9997 77.7168C50.2821 77.7168 46.2837 78.8592 41.7142 82.2864C40.0006 83.4288 37.1446 83.4288 36.0022 81.7152C34.8598 80.0016 34.8542 77.1456 36.5734 76.0032C42.8566 71.4281 47.9973 69.1433 56.5709 69.1433C65.1388 69.1433 69.714 70.8569 76.574 75.9977C77.7163 77.14 77.7163 79.4304 76.574 81.7096L76.5684 81.7152ZM73.1412 44.5706C70.2852 44.5706 67.4292 41.7146 67.4292 38.8587C67.4292 36.0027 70.2852 33.1467 73.1412 33.1467C75.9972 33.1467 78.8531 36.0027 78.8531 38.8587C78.8531 41.7146 75.9972 44.5706 73.1412 44.5706Z",
    fill: "#F96619"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_76_6061"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 112,
    height: 112,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcErrorFace);
export default __webpack_public_path__ + "static/media/ic_error_face.3abaac4c8694144d6498570df945e753.svg";
export { ForwardRef as ReactComponent };